<template>
  <div id="data-rule-list-view" class="data-list-container">
    <vx-card>
      <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="rulesList"
        :noDataText="noDataText"
        color="warning"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse cursor-pointer items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container w-full"
          >
            <!-- ADD NEW -->
            <div class="w-full btn-add-new mb-4 mr-4">
              <vs-button
                class="text-white"
                color="warning"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                @click="addNewData"
                >{{ $t("rules.main.AddRule") }}</vs-button
              >
            </div>
          </div>
        </div>

        <template slot="thead">
          <vs-th class="text-left rule-name">{{
            $t("rules.main.thead.Name")
          }}</vs-th>
          <vs-th class="text-center">{{ $t("rules.main.thead.Rules") }}</vs-th>
          <vs-th class="text-center">{{
            $t("rules.main.thead.ApiaryCount")
          }}</vs-th>
          <vs-th class="text-center">{{
            $t("rules.main.thead.NotificationType")
          }}</vs-th>
          <vs-th class="text-center">{{
            $t("rules.main.thead.Actions")
          }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="text-left">
                <p class="rule-name font-medium truncate mr-0">
                  {{ tr.rule_name }}
                </p>
              </vs-td>
              <vs-td class="text-center" style="width: 250px">
                <div class="w-full text-center flex justify-center">
                  <div
                    :key="i"
                    v-for="(set, i) in tr.rule_sets"
                  >
                    <vs-chip
                      transparent
                      color="primary"
                      class="mx-1"
                      v-if="set == 'temp'"
                    >
                      {{ $t("rules.new.DataTypeOptions.Temperature") }}
                    </vs-chip>
                    <vs-chip
                      transparent
                      color="warning"
                      class="mx-1"
                      v-if="set == 'hum'"
                    >
                      {{ $t("rules.new.DataTypeOptions.Humidity") }}
                    </vs-chip>
                    <vs-chip
                      transparent
                      color="success"
                      class="mx-1"
                      v-if="set == 'vibe'"
                    >
                      {{ $t("rules.new.DataTypeOptions.Vibration") }}
                    </vs-chip>
                  </div>
                </div>
              </vs-td>
              <vs-td class="text-center">
                <p>{{ tr.total_apiary_count }}</p>
              </vs-td>
              <vs-td class="text-center" style="min-width: 180px">
                <div class="w-full text-center flex justify-center">
                  <VxTooltip
                    position="bottom"
                    color="dark"
                    :text="$t('rules.main.NotificationSettingsTooltips.Sms')"
                  >
                   <feather-icon icon="MessageCircleIcon" v-if="tr.sms_notification==true" class="mx-2 text-primary" svgClasses="w-6 h-6" />
                  </VxTooltip>
                  <VxTooltip
                    position="bottom"
                    color="dark"
                    :text="$t('rules.main.NotificationSettingsTooltips.Email')"
                  >
                  <feather-icon icon="MailIcon" v-if="tr.email_notification==true" class="mx-2 text-success"  svgClasses="w-6 h-6"/>
                  </VxTooltip>
                    <VxTooltip
                    position="bottom"
                    color="dark"
                    :text="$t('rules.main.NotificationSettingsTooltips.Platform')"
                  >
                  <feather-icon icon="MonitorIcon"  v-if="tr.platform_notification==true" class="mx-2 text-warning"  svgClasses="w-6 h-6"/>
                  </VxTooltip>
                </div>
              </vs-td>
              <vs-td
                class="whitespace-no-wrap text-center"
                style="width: 120px"
              >
                <div class="flex justify-center">
                  <VxTooltip
                    position="bottom"
                    color="dark"
                    :text="$t('breadcrumbs.EditRule')"
                  >
                    <feather-icon
                      class="cursor-pointer"
                      icon="EditIcon"
                      svgClasses="w-5 h-5 hover:text-success stroke-current"
                      @click.stop="editRule(tr.id)"
                    />
                  </VxTooltip>
                  <VxTooltip
                    position="bottom"
                    color="dark"
                    :text="$t('rules.delete.Title')"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="ml-2 cursor-pointer"
                      @click.stop="deleteRule(tr.id)"
                    />
                  </VxTooltip>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import i18n from '../../i18n/i18n.js'
import VxTooltip from '../../layouts/components/vx-tooltip/VxTooltip.vue'
export default {
  components: {
    VxTooltip
  },
  data () {
    return {
      itemsPerPage: 10,
      rulesList: [],
      noDataText: i18n.t('table.LoadingText')
    }
  },
  created () {
    this.getRulesList()
  },
  computed: {
    rulesData () {
      return this.$store.getters.returnRulesData
    }
  },
  methods: {
    getRulesList () {
      this.$store
        .dispatch('getRulesList')
        .then((response) => {
          if (response.data.length === 0) {
            this.noDataText = i18n.t('rules.main.NoRules')
          } else {
            this.noDataText = i18n.t('table.NoMatch')
          }
          this.rulesList = this.rulesData
        })
        .catch((error) => {
          this.noDataText = i18n.t('alarms.NoDataError')
          this.errorMsg(error)
        })
    },
    addNewData () {
      this.$router.push('/rules/new')
    },
    editRule (id) {
      this.$router.push(`/rules/rule/edit/${  id}`)
    },
    deleteRule (id) {
      this.$router.push(`/rules/rule/delete/${  id}`)
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>
<style lang="scss">
#data-rule-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    .vs-table--search-input {
      border-radius: 5px !important;
    }

    .vs-table--search-input:focus+i {
      color: #ff9f43 !important;
    }   

    @media (max-width: 576px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }

      .btn-add-new {
        button {
          width: 100%;
        }
        margin-right: 0 !important;
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .rule-name {
      max-width: 18rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
          display: none;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        padding: 0 20px !important;
        text-align: center;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          justify-content: center !important;
          text-align: center;
        }
      }
      th.rule-name {
        .vs-table-text {
          justify-content: left !important;
        }
      }
      th.td-check {
        padding: 0 20px !important;
        display: none;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  .vs-pagination--li.is-current {
    background: #ff9f43 !important;
  }
  .vs-pagination-primary .effect,
  .vs-pagination-primary .vs-pagination--buttons:hover {
    background: #ff9f43 !important;
  }

  .apiaries-list-part span {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
  }
  .not-data-table {
    background: #fff;
    padding: 20px;
    font-weight: 600;
    border-radius: 0.5rem;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  }
  .vs-table--tbody-table .tr-values.selected {
    cursor: default;
  }

  .border-dark {
    border-color: rgba(98, 98, 98, 1) !important;
  }
}
</style>
